import { FC } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AppProps } from './app.props';
import styles from './app.module.scss';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { DeviceInfo } from '../device-info';
import { Start } from '../start';
import { Video } from '../video';
import { FirstPage } from '../first-page';

/**
 * <App />
 */
const App: FC<AppProps> = observer(() => {
  const location = useLocation();

  return (
    <div
      className={classNames(styles.app, {
        [styles.isHome]: location.pathname === '/devices',
        [styles.isVideo]: location.pathname === '/video',
        [styles.isFirstPage]: location.pathname === '/'
      })}
    >
      <Routes>
        <Route path='/' Component={FirstPage} />
        <Route path='/video' Component={Video} />
        <Route path='/devices' Component={Start} />
        <Route path='/device-info/:path' Component={DeviceInfo} />
        <Route path='*' Component={Start} />
      </Routes>
      <div className={styles.footer}>
        Не виключає всіх ризиків. Аерозоль містить нікотин, що викликає
        залежність. Тільки для використання повнолітніми. Ця інформація
        про продукт надається споживачу за його згодою відповідно до ч.
        2 ст. 15 ЗУ «Про захист прав споживачів». Передпродаж доступний
        для учасників IQOS 360. Ціна за даними iqos.ua станом на 27.08.
      </div>
    </div>
  );
});

export { App };
